import { render, staticRenderFns } from "./FunnelsLayer.vue?vue&type=template&id=881f91c6&scoped=true"
import script from "./FunnelsLayer.vue?vue&type=script&lang=js"
export * from "./FunnelsLayer.vue?vue&type=script&lang=js"
import style0 from "./FunnelsLayer.vue?vue&type=style&index=0&id=881f91c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881f91c6",
  null
  
)

export default component.exports